import { Spinner } from "react-bootstrap";

export const LoadingSuspense = () =>
  <div className="loading-suspense">
    <Spinner animation="border" role="status" variant="primary" />
  </div>;
